/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { NodeCompat } from '../../compat/NodeCompat';
import { Constants } from '../../core/Constants';
import { ExtensibleNode } from '../../core/models/ExtensibleNode';
import { IIndexedNode } from '../../core/models/IIndexedNode';
import { IVisitor } from '../../core/visitors/IVisitor';
import { IOasVisitor } from '../visitors/IOasVisitor';

/**
 * Models an OpenAPI responses.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends ExtensibleNode
 */
export abstract class OasResponses extends ExtensibleNode implements IIndexedNode<OasResponse> {
    public default_ : OasResponse;

    /*private*/ _responses : any;

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOasVisitor = <IOasVisitor><any>visitor;
        viz.visitResponses(this);
    }

    /**
     * Returns a single response by status code.
     * @param {string} statusCode
     * @return {OasResponse}
     */
    public getResponse(statusCode : string) : OasResponse {
        if(NodeCompat.equals(statusCode, Constants.PROP_DEFAULT)) {
            return this.default_;
        }
        if(this._responses != null) {
            return /* get */((m,k) => m[k]===undefined?null:m[k])(this._responses, statusCode);
        }
        return null;
    }

    /**
     * Returns an array of all the responses.
     * @return {OasResponse[]}
     */
    public getResponses() : Array<OasResponse> {
        let rval : Array<OasResponse> = <any>([]);
        if(this._responses != null) {
            /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this._responses));
        }
        if(this.default_ != null) {
            /* add */(rval.push(this.default_)>0);
        }
        return rval;
    }

    /**
     * Adds a response.
     * @param {string} statusCode
     * @param {OasResponse} response
     * @return {OasResponse}
     */
    public addResponse(statusCode : string, response : OasResponse) : OasResponse {
        if(statusCode == null || NodeCompat.equals(statusCode, Constants.PROP_DEFAULT)) {
            this.default_ = response;
            return response;
        }
        if(this._responses == null) {
            this._responses = <any>({});
        }
        /* put */(this._responses[statusCode] = response);
        return response;
    }

    /**
     * Removes a single response child model.
     * @param {string} statusCode
     * @return {OasResponse}
     */
    public removeResponse(statusCode : string) : OasResponse {
        if(statusCode == null || NodeCompat.equals(statusCode, Constants.PROP_DEFAULT)) {
            let rval : OasResponse = this.default_;
            this.default_ = null;
            return rval;
        }
        if(this._responses != null) {
            return /* remove */(map => { let deleted = this._responses[statusCode];delete this._responses[statusCode];return deleted;})(this._responses);
        }
        return null;
    }

    /**
     * Gets a list of all the response status codes.
     * @return {string[]}
     */
    public getResponseStatusCodes() : Array<string> {
        let rval : Array<string> = <any>([]);
        if(this._responses != null) {
            /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* keySet */Object.keys(this._responses));
        }
        return rval;
    }

    /**
     * Creates an OAS Response object.
     * @param {string} statusCode
     * @return {OasResponse}
     */
    public abstract createResponse(statusCode : string) : OasResponse;

    /**
     * Creates a default OAS response.
     * @return {OasResponse}
     */
    public createDefaultResponse() : OasResponse {
        return this.createResponse(null);
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItem(java.lang.String)
     * @param {string} name
     * @return {OasResponse}
     */
    public getItem(name : string) : OasResponse {
        return this.getResponse(name);
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItems()
     * @return {OasResponse[]}
     */
    public getItems() : Array<OasResponse> {
        return this.getResponses();
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItemNames()
     * @return {string[]}
     */
    public getItemNames() : Array<string> {
        return this.getResponseStatusCodes();
    }

    public addItem$java_lang_String$io_apicurio_datamodels_openapi_models_OasResponse(name : string, item : OasResponse) {
        this.addResponse(name, item);
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#addItem(java.lang.String, io.apicurio.datamodels.core.models.Node)
     * @param {string} name
     * @param {OasResponse} item
     */
    public addItem(name? : any, item? : any) : any {
        if(((typeof name === 'string') || name === null) && ((item != null && item instanceof <any>OasResponse) || item === null)) {
            return <any>this.addItem$java_lang_String$io_apicurio_datamodels_openapi_models_OasResponse(name, item);
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#deleteItem(java.lang.String)
     * @param {string} name
     * @return {OasResponse}
     */
    public deleteItem(name : string) : OasResponse {
        return this.removeResponse(name);
    }

    constructor() {
        super();
        if(this.default_===undefined) this.default_ = null;
        if(this._responses===undefined) this._responses = null;
    }
}
OasResponses["__class"] = "io.apicurio.datamodels.openapi.models.OasResponses";
OasResponses["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IIndexedNode"];





import { OasResponse } from './OasResponse';

